import React from 'react';
import { Checkbox, Popconfirm } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import moment from 'moment';

export const driverlessColumns = (context) => [
    {
        title: 'STT',
        dataIndex: 'index',
        key: 'index',
        fixed: true,
        className: 'column-60 inherit-background',
        editable: false,
        render: (index, record) => {
            const { expandedRows } = context;
            const check = expandedRows.findIndex(value => value === record.key);
            return <span className="expand-container" onClick={() => {

                context.onExpand(record)
            }}>
                {record.children && record.children.length > 0 && (
                    check !== -1 ? <CaretUpOutlined className="expand-icon" /> : <CaretDownOutlined className="expand-icon" />
                )}
                {index}
            </span>
        }
    },
    {
        title: 'Thứ',
        fixed: true,
        className: 'column-80 inherit-background',
        dataIndex: 'week_day', // should edit 
        key: 'week_day',
        editable: false,
    },
    {
        title: 'Ngày',
        fixed: true,
        dataIndex: 'date',
        key: 'date',
        editable: false,
        className: 'column-80 inherit-background',
        render: date => {
            return <div>{moment(date).format('DD/MM/YYYY')}</div>
        }
    },
    {
        title: 'Hành trình chuyến đi',
        className: 'column-300',
        dataIndex: 'trip_itinerary',
        key: 'trip_itinerary',
        inputType: 'input-text',
        editable: false,
        render: list => {
            return <span>
                {list.map((item, index) => {
                    return item && <>
                        <span key={index} className="link-container">
                            {item}
                        </span>
                        <br />
                    </>
                })}
            </span>
        }
    },
    {
        title: 'Số km bắt đầu',
        dataIndex: 'km_start',
        editable: true,
        key: 'km_start',
        //className: 'column-80',
        isPercent: false,
        inputType: 'input-number'
    },
    {
        title: 'Số km kết thúc',
        dataIndex: 'km_end',
        editable: true,
        key: 'km_end',
        isPercent: false,
        inputType: 'input-number'
    },
    {
        title: 'Số km đã đi',
        dataIndex: 'used_km',
        editable: false,
        key: 'used_km',
        isPercent: false,
        inputType: 'input-number'
    },
    {
        title: 'Over km (Km)',
        dataIndex: 'over_km',
        editable: false,
        key: 'over_km',
        inputType: 'input-number'
    },
    {
        title: 'Tài xế',
        dataIndex: 'driver_name',
        editable: false,
        key: 'driver_name',
        inputType: 'input-text',
        render: list => {
            return <span>
                {list.map((item, index) => {
                    return item && <>
                        <span key={index} className="link-container">
                            {item}
                        </span>
                        <br />
                    </>
                })}
            </span>
        }
    },
    {
        title: 'Biển KS',
        dataIndex: 'vehicle_number_plate',
        editable: false,
        key: 'vehicle_number_plate',
        inputType: 'input-text',
        render: list => {
            return <span>
                {list.map((item, index) => {
                    return item && <>
                        <span key={index} className="link-container">
                            {item}
                        </span>
                        <br />
                    </>
                })}
            </span>
        }
    },
    {
        title: 'Ảnh ODO (Hệ thống không nhận dạng được)',
        className: 'column-200',
        dataIndex: 'image_odo_links',
        editable: false,
        key: 'image_odo_links',
        render: links => {
            if (!links) {
                return ''
            }
            return <span>
                {links.map((link, index) => {
                    return link && <span className="link-container">
                        <a target="_blank" className="one-line-link" href={link}>
                            Link{index}
                        </a>{index !== links.length - 1 ? ', ' : ''}
                    </span>
                })}
            </span>
        }
    },
    {
        title: 'Ghi chú',
        className: 'column-200 noteMW',
        dataIndex: 'note',
        editable: true,
        key: 'note',
        render: list => {
            return <span>
                {list.map((item, index) => {
                    return item && <>
                        <span key={index} className="link-container">
                            {item}
                        </span>
                        <br />
                    </>
                })}
            </span>
        }
    },
    {
        title: '',
        dataIndex: 'operation',
        key: 'operation',
        render: (_, record) => {
            const editable = context.isEditing(record);
            const lockEdit = context.props.lockTime >= context.state.date.start ? true : false;
            return editable ? (
                <span>
                    <a disabled={context.state.buttonDisable} onClick={() => context.save(record)} style={styles.mr8}>Lưu</a>
                    <Popconfirm overlayClassName="white-pupop" cancelText="Huỷ" okText={"Chấp nhận"} title="Bạn có chắc chắn muốn huỷ?" onConfirm={context.cancel}>
                        <a style={styles.mr8}>Huỷ</a>
                    </Popconfirm>
                </span>
            ) : (record.children !== undefined ?
                <span>
                    {(record.children.length === 0) && record.journey_diary_id && <a disabled={context.state.editingKey !== '' || lockEdit} style={styles.mr8} onClick={() => context.edit(record)}>Sửa</a>}
                </span> :
                <span>
                    <a style={styles.mr8} disabled={context.state.editingKey !== '' || lockEdit} onClick={() => context.edit(record)}>
                        Sửa
                    </a>
                </span>
                );
        },
    },
];

const styles = {
    mr8: {
        marginRight: 8
    }
}